export default `
    <div class="login-header #=data.bsc||""#">
        #= data.title #
    </div>
    <div class="login-logo">
        <div class="#= data.classes #"></div>
    </div>
`;
